import { render, staticRenderFns } from "./site-markup.vue?vue&type=template&id=df9d1d1c&"
import script from "./site-markup.vue?vue&type=script&lang=js&"
export * from "./site-markup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports